import React from "react";

const SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='280' height='170'><text x='140' y='95' font-size='17' font-weight='700' fill='rgba(255,255,255,0.30)' stroke='rgba(0,0,0,0.28)' stroke-width='0.6' text-anchor='middle' transform='rotate(-25 140 85)' font-family='Tajawal, Arial, sans-serif'>رواج الذكية · RAWAJ SMART</text></svg>`
);

/** غلاف حماية للعينات: علامة مائية متكررة باسم رواج الذكية فوق أي صورة/فيديو معروض + منع السحب وقائمة الحفظ */
export const Watermarked = ({ children, className = "", label = true, testId = "watermarked" }) => (
  <div className={`relative overflow-hidden select-none ${className}`} onContextMenu={(e) => e.preventDefault()} onDragStart={(e) => e.preventDefault()} data-testid={testId}>
    {children}
    <div aria-hidden className="pointer-events-none absolute inset-0 z-10" style={{ backgroundImage: `url("data:image/svg+xml,${SVG}")`, backgroundSize: "280px 170px" }} data-testid="watermark-layer" />
    {label && <span className="pointer-events-none absolute bottom-1 start-1 z-10 rounded bg-black/60 text-white text-[10px] px-1.5 py-0.5">عينة محمية © رواج الذكية</span>}
  </div>
);
